import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'
import { GETResponse } from 'helpers'

export interface IPostConceptConfiguration {
  Application: string
  Configurations: ConfigurationItem[]
}

export interface ConfigurationItem {
  Type: string
  Values: string
}
export interface DBConceptConfigurations {
  UUID: string
  Application: string
  Type: string
  Value: string
  CreatedAt: string
  UpdatedAt: string
  UpdatedByName: string
  UpdatedByType: string
  UpdatedByUUID: string
  CreatedByType: string
  CreatedByUUID: string
  CreatedByName: string
}

export interface GetConfigurationByConceptList {
  Configurations: DBConceptConfigurations[]
}

export interface Response {
  Data: GetConfigurationByConceptList
}

export interface GetList {
  ConceptConfiguration: Config
}

export type GETConceptListResponse = GETResponse<GetList[]>

export interface Config {
  Application: string
  Facilities: []
  PaymentMethods: []
  Services: []
}

export const updateConceptConfiguration = (values: IPostConceptConfiguration) =>
  createAsyncApiAction<string>('support', {
    method: 'POST',
    url: `/modules/concept-configuration`,
    data: values
  })

export const getConceptCobfigurationByConcept = (concept: string) =>
  createAsyncApiAction<Response>('support', {
    method: 'GET',
    url: `/modules/concept-configuration/${concept}`
  })

export const getConceptConfigurationList = () =>
  createAsyncApiAction<GetList>('support', {
    method: 'GET',
    url: 'modules/concept-configuration/list'
  })
